"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyImage = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _common = require("../../common");
var _ImagePlaceholder = require("../ImagePlaceholder");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LazyImage = ({
  alt,
  customImagePlaceholder,
  imageRef,
  placeholderHeight,
  placeholderWidth,
  placeholderAbsolute,
  src,
  srcSet,
  testId,
  onImageLoad,
  onLoad,
  ...restProps
}) => {
  const localRef = (0, _react.useRef)(null);
  const ref = (0, _react.useMemo)(() => imageRef ?? localRef, [imageRef]);
  const [isPlaceholderVisible, setIsPlaceholderVisible] = (0, _react.useState)(true);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const handleLoad = (0, _react.useCallback)(e => {
    setIsPlaceholderVisible(false);
    onLoad?.(e);
  }, [onLoad]);
  const handleLoadEvent = (0, _react.useCallback)(() => {
    onImageLoad?.();
  }, [onImageLoad]);
  (0, _react.useEffect)(() => {
    const lazyImageElement = ref.current;
    // istanbul ignore next -- Not reachable in tests
    if ((Boolean(src) || Boolean(srcSet)) && isPlaceholderVisible && lazyImageElement?.complete) {
      setIsPlaceholderVisible(false);
    }
    lazyImageElement?.addEventListener('load', handleLoadEvent);
    return () => {
      lazyImageElement?.removeEventListener('load', handleLoadEvent);
    };
  }, [handleLoadEvent, isPlaceholderVisible, ref, src, srcSet]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isPlaceholderVisible ? customImagePlaceholder ?? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImagePlaceholder.ImagePlaceholder, {
      isLoadingPlaceholder: true,
      absolute: placeholderAbsolute,
      isSquare: placeholderHeight === undefined && placeholderWidth === undefined,
      height: placeholderHeight,
      width: placeholderWidth
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Img, {
      ref: ref,
      alt: alt ?? src,
      src: src,
      srcSet: srcSet,
      "data-testid": testId ?? getTestId(_common.LAZY_IMAGE),
      role: "presentation",
      isPlaceholderVisible: isPlaceholderVisible,
      onLoad: handleLoad,
      ...restProps
    })]
  });
};
exports.LazyImage = LazyImage;
//# sourceMappingURL=LazyImage.js.map